function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  d: "M19.5 67.5h169v45h-169zM.5 80.5h19v22H.5zM188.5 80.5h19v22h-19z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  d: "M19.5 86.5h169v10h-169z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M188.756 79.78c-16.928 0-16.966-8.78-33.984-8.78s-16.98 8.78-33.959 8.78c-16.98 0-16.954-8.78-33.908-8.78s-16.98 8.78-33.959 8.78C35.966 79.78 35.966 71 19 71v42h169.787s.499-33.22-.03-33.22z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  d: "M96.371.423v31.029c0 10.422-8.449 18.87-18.87 18.87-10.423 0-18.872-8.448-18.872-18.87V.422M105.807-.001l22.016 51.581h0L149.839-.001"
}));

function SvgRoomUvLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 208,
    height: 113,
    viewBox: "0 0 208 113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomUvLight);
export default __webpack_public_path__ + "static/media/RoomUvLight.9f1f3956.svg";
export { ForwardRef as ReactComponent };